var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row nftmax-gap-sq30"},[_vm._l((_vm.products),function(product,index){return [_c('div',{key:index,staticClass:"col-xxl-3 col-lg-3 col-md-6 col-12"},[_c('ProductCardStyleOne',{attrs:{"datas":product}})],1)]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }